import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { useUnmount } from 'react-use';
import { Form, Input, Button, Space } from 'antd';
import { Animated } from 'react-animated-css';

import { Container, A } from './styles';
import { FormattedMessage } from 'vendys-commons/decorators/views';
import { FormattedMessageDynamic } from 'utils';

interface AddressPostProps {
  onChange: (v) => {};
  visibleLabel: boolean;
}

function AddressPost(props: AddressPostProps) {
  const { onChange = (v) => {}, visibleLabel = true, value } = props;

  const [_address, setAddress] = useState({});
  const [visible, setVisible] = useState({});
  const [form] = Form.useForm();

  const [_value, setValue] = useState({});
  const [isUpdated, setUpdate] = useState(true);

  useUnmount(() => {
    onChange(undefined);
  });

  const openPost = () => {
    if (!kakao) {
      return alert('다음 라이브러리가 존재하지 않습니다.');
    }
    var width = 500; //팝업의 너비
    var height = 600; //팝업의 높이

    new kakao.Postcode({
      oncomplete: function(data) {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
        const {
          address,
          zonecode,
          jibunAddress,
          buildingName,
          buildingCode,
          roadAddress,
          addressType,
          userSelectedType,
          sido,
          sigungu,
          autoJibunAddress
        } = data; // zonecode
        setValue({ ..._value, jibunAddress, roadAddress, zonecode, userSelectedType });
        setAddress(data);
        form.setFieldsValue({ ...data, addressDetail: undefined });
        setVisible({ ['address']: true });
        form.validateFields();
        const _jibunAddress = jibunAddress ? jibunAddress : autoJibunAddress;
        onChange({ ..._value, jibunAddress: _jibunAddress, roadAddress, zonecode, userSelectedType });
      }
    }).open({
      left: window.screen.width / 2 - width / 2,
      top: window.screen.height / 2 - height / 2
    });
  };

  const onValuesChange = (changeValues, allValues) => {
    const {
      address,
      zonecode,
      jibunAddress,
      buildingName,
      buildingCode,
      addressType,
      roadAddress,
      sido,
      sigungu
    } = _address; // zonecode

    onChange({ zonecode, roadAddress, jibunAddress, addressType, ...allValues });

    form
      .validateFields()
      .then((values) => {})
      .catch((errorInfo) => {
        //
        const { errorFields } = errorInfo;
        var key = 'address';
        var keyIsError = false;
        errorFields.forEach((row) => {
          if (row.name.indexOf(key) > 0) {
            keyIsError = true;
          }
        });

        if (keyIsError === false) {
          setVisible({ [key]: true });
        }
      });
  };

  const _onChange = (k, v) => {
    setValue({ ..._value, [k]: v });
    onChange({ ..._value, [k]: v });
  };
  // useEffect(()=>{
  //   if(!isUpdated) return;
  //   onChange(_value)
  // },[_value])
  useEffect(() => {
    if (!value) return;
    if (value.constructor != Object) {
      return console.error('Addresspost component get empty value!!!');
    }
    setValue(value);
    var key = 'address';
    setVisible({ [key]: true });
  }, [value]);

  return (
    <Container visibleLabel={visibleLabel}>
      <A animationIn="fadeInUp" animationInDuration={1000} animationOutDuration={1000} isVisible={true}>
        <Space direction="vertical">
          <Space>
            <Button onClick={openPost}>
              <FormattedMessage id="quick.address.search" />
            </Button>
            <div>{_value.roadAddress}</div>
          </Space>
          {/* <Input value="adsf" /> */}
          <Input
            readOnly
            name="address"
            style={{ display: 'none' }}
            value={_value.roadAddress}
            onChange={(e) => _onChange('roadAddress', e.target.value)}
          />
          {/* <Input readOnly id="address" style={{display: 'none'}} value={_value.roadAddress}/> */}
          <Input
            name="addressDetail"
            placeholder={'상세 주소'}
            value={_value.addressDetail}
            onChange={(e) => _onChange('addressDetail', e.target.value)}
            style={{
              height: visible['address'] ? 'auto' : '0px',
              opacity: visible['address'] ? 1 : 0,
              visibility: visible['address'] ? 'visible' : 'hidden'
            }}
          />
        </Space>
      </A>
    </Container>
  );
}

export default AddressPost;
